import { useEffect } from 'react'
import { readCookie, deleteCookie } from '@/lib/cookies'
import { IMPERS_STASH_COOKIE, IMPERS_ACTIVE_TAB_KEY } from './storage-keys'
import type { ImpersonationAdminStash } from './types'

/**
 * Restaura stash do cookie quando reload acontece durante impersonação.
 *
 * IMPORTANTE: cookie é cross-subdomain (.runnaflow.com) — TODAS as abas em
 * *.runnaflow.com podem lê-lo. Por isso usamos sessionStorage (per-tab) como
 * flag "ESTA aba é a que está impersonando". Na aba admin origem, o cookie
 * existe mas a flag não → admin continua admin.
 */
export function useImpersonationRestore(setImpersStash: (s: ImpersonationAdminStash) => void) {
  useEffect(() => {
    if (typeof window === 'undefined') return
    const flag = sessionStorage.getItem(IMPERS_ACTIVE_TAB_KEY)
    if (flag !== '1') return
    const raw = readCookie(IMPERS_STASH_COOKIE)
    if (!raw) {
      sessionStorage.removeItem(IMPERS_ACTIVE_TAB_KEY)
      return
    }
    try {
      const parsed = JSON.parse(raw) as ImpersonationAdminStash
      if (parsed?.admin_access_token) setImpersStash(parsed)
    } catch {
      deleteCookie(IMPERS_STASH_COOKIE)
      sessionStorage.removeItem(IMPERS_ACTIVE_TAB_KEY)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
